import ApiClient from './ApiClient';

class BroadcastCampaignsAPI extends ApiClient {
  constructor() {
    super('broadcast_campaigns', { accountScoped: true });
  }
}

export default new BroadcastCampaignsAPI();
